const YandexIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="12" cy="12" r="12" fill="#FC3F1D" />
      <path
        d="M13.32 18.667h2.027V5.333h-2.947c-2.96 0-4.52 1.52-4.52 3.76 0 1.787.853 2.84 2.373 3.92l-2.64 3.947 -2.04 3.04h2.187l2.96-4.413 1.027-1.534-1.027-.747c-1.227-.827-1.827-1.467-1.827-2.84 0-1.2.84-2.013 2.107-2.013h.92v9.214Z"
        fill="white"
      />
    </svg>
  );
};

export default YandexIcon;
